// some small useful functions (so we don't reference underscore or lodash)

export function isNumber(arg: any) {
  return typeof arg === "number";
}

export function isString(arg: any) {
  return typeof arg === "string";
}

export function isObject(arg: any) {
  return typeof arg === "object" && arg !== null;
}

export function isArray(arg: any) {
  // TODO optimize
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return toString.call(arg) === "[object Array]";
}
export function isUndefined(arg: any) {
  return typeof arg === "undefined";
}

export function isUndefinedOrNull(arg: any) {
  return arg === null || typeof arg === "undefined";
}

export function isNullOrWhiteSpace(str: string) {
  return (typeof str !== "string" || !str || str.length === 0 || /^\s*$/.test(str));
}

export function isBoolean(obj: any) {
  return obj === true || obj === false || toString.call(obj) === "[object Boolean]";
}

/**
 * Checks if an object is empty (has no properties)
 * @private
 */
export function isEmpty(arg: any) {
  for (const prop in arg) {
    if (arg.hasOwnProperty(prop)) {
      return false;
    }
  }
  return true;
}

export function isFunction(arg: any) {
  return !!(arg && arg.constructor && arg.call && arg.apply);
}

export function some<T>(array: T[], predicate: (el: any, index: number) => boolean) {
  for (let index = 0; index < array.length; index++) {
    if (predicate(array[index], index)) {
      return true;
    }
  }
  return false;
}

export function first<T>(array: T[], predicate: (el: any, index: number) => boolean) {
  for (let index = 0; index < array.length; index++) {
    if (predicate(array[index], index)) {
      return array[index];
    }
  }
  return undefined;
}

export function ifNotUndefined<T>(what: T, doWithIt: (what: T) => void) {
  if (typeof what !== "undefined") {
    doWithIt(what);
  }
}

export function promisify(promise: Promise<any>, successCallback: () => void, errorCallback: () => void) {
  "use strict";
  if (typeof successCallback !== "function" && typeof errorCallback !== "function") {
    return promise;
  }

  if (typeof successCallback !== "function") {
    successCallback = () => { return; };
  } else if (typeof errorCallback !== "function") {
    errorCallback = () => { return; };
  }

  promise.then(successCallback, errorCallback);
}
